import { useEffect } from 'react';
import type { ISettingDTOData } from '../../dtos/ProdegaApiWebshop-api-typings-generated';
import { getLogger } from '~/logging/logger.ts';

const log = getLogger('use-client-settings');

let CLIENT_SETTINGS: ISettingDTOData[] | undefined;
let updateClientSetting: ((settingName: string, value: string) => Promise<void>) | undefined;

export const UPDATE_CLIENT_SETTING = async (settingName: string, value: string): Promise<void> => {
  await updateClientSetting?.(settingName, value);
};

export function useClientSettings(settings: ISettingDTOData[] | undefined) {

  useEffect(() => {
    CLIENT_SETTINGS = settings;

    if (typeof window !== 'undefined') {
      function showSettings() {
        log.info('SETTINGS', CLIENT_SETTINGS);
      }

      async function setSettingValue(clientSettingName: string, value: any) {
        if (typeof window === 'undefined') return;

        try {
          await fetch('/infra/save-user-setting', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              clientSettingName,
              value
            })
          });
          window.location.reload();
        } catch (error) {
          log.error('Failed to save user setting:', error);
        }
      }

      updateClientSetting = setSettingValue;
      window['__TGS__'] = {
        showSettings,
        setSettingValue
      };
    }
  }, [settings]);
}
